/* ========================== */
/* ========= import ========= */
/* ========================== */

/* ====== React ====== */
import React from 'react'
import { useState } from 'react';

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Component Js/Jsx ====== */
import { FONTSIZE_STORAGE } from '03CommonApiParts/CodeDefinition';
import { assets } from '03CommonApiParts/Configuration';

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------　フォントサイズボタン ------*/
const SdivWrapper = styled.div`//ボタンの枠
    display: flex;
    align-items: center;
    /* width:100px; */
`;
const SdivButton = styled.div`//ボタンの本体
    display: flex;
    font-weight: bold;
`;
const SinputRadio = styled.input`//ボタンのラジオ欄
    display: none;
`;
const SlabelFonsSize = styled.label`//フォントサイズのラベル
    width: 25px;
    height: 25px;
    color: ${props => props.state === props.type ? 'white' : '#2E94B9'};
    border: 2px solid #2E94B9;
    background-color:${props => props.state === props.type ? '#2E94B9' : 'white'};
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    &#first {
        border-radius: 5px 0 0 5px;
        border-right: none;
        font-size: 18px;
    };
    &#second {
        border-radius: 0;
        font-size: 16px;
    };
    &#third {
        border-radius: 0 5px 5px 0;
        border-left: none;
        font-size: 14px;
    };
`;
const SspanTooltip = styled.span`//ステータスバーのツールチップ
    position: relative;
    padding-left: 3px;
    padding-right: 3px;
    height: fit-content;
    right: -50%;
    top: 35px;
    background: #4b4b4b;
    color: #FFF;
    border-radius: 3px;
    visibility: ${props => props.visible ? '': 'hidden'};
    z-index:40;
    pointer-events: none;
    &:after{
        content: "";
        position: absolute;
        top: -80%;
        left: 43%;
        border: 5px solid transparent;
        border-bottom: 14px solid #4b4b4b; 
        z-index:-1;
    }
`;
/* ============================= */
/* ========= 共通パーツ ========= */
/* ============================= */

/* ====== フォントサイズボタン ====== */
export const FontSizeButton = () => {
    /* ============================= */
    /* ========= state ============= */
    /* ============================= */
    const [visible, setVisible] = useState(false);
    const [typeState, SetTypeState] = useState(localStorage.getItem(FONTSIZE_STORAGE)?localStorage.getItem(FONTSIZE_STORAGE):'medium'); //localStorageに保存されている値をStateに初期値としてセット
    const onClickFontSize = (event) => {
        SetTypeState(event.target.value);//Stateにセット
        localStorage.setItem(FONTSIZE_STORAGE, event.target.value); //localStorageにセット
        const storageToken = localStorage.getItem(FONTSIZE_STORAGE) ? localStorage.getItem(FONTSIZE_STORAGE) : 'medium';
        const headText = document.getElementsByClassName('headText');
        const titleText = document.getElementsByClassName('titleText');
        const baseText = document.getElementsByClassName('baseText');
        const inputText = document.getElementsByClassName('inputText');
        const inputlabelText = document.getElementsByClassName('inputlabelText');
        const buttonStyle = document.getElementsByClassName('buttonStyle');
        const iconButtonStyle = document.getElementsByClassName('iconButtonStyle');
        const dialogButtonStyle = document.getElementsByClassName('dialogButtonStyle');
        const svgStyle = document.getElementsByClassName('svgStyle');
        const tableSvgStyle = document.getElementsByClassName('tableSvgStyle');
        const categoryStyle = document.getElementsByClassName('categoryStyle');
        const fontsizeButtonTooltipText = document.getElementsByClassName('fontsizeButtonTooltipText');
        const anchorStyle = document.getElementsByClassName('anchorStyle');
        const tableCellStyle = document.getElementsByClassName('tableCellStyle');
        const tableStyle = document.getElementsByClassName('tableStyle');
        const tableSmallLabel = document.getElementsByClassName('tableSmallLabel');
        const tableHeightsize = document.getElementsByClassName('tableHeightsize');
        const tableSmallHeightsize = document.getElementsByClassName('tableSmallHeightsize');
        const leftTableCellR = document.getElementsByClassName('leftTableCellR');
        const leftTableCellL = document.getElementsByClassName('leftTableCellL');
        const commentInputHeight = document.getElementsByClassName('commentInputHeight');
        const priorityTagStyle = document.getElementsByClassName('priorityTagStyle');
        const statusTagStyle = document.getElementsByClassName('statusTagStyle');
        const newTagStyle = document.getElementsByClassName('newTagStyle');
        const tableSmalSVG = document.getElementsByClassName('tableSmalSVG');

        const FormatButtonStyle = document.getElementsByClassName('FormatButtonStyle');


        if(headText.length > 0){
            let i;
            for(i = 0; i < headText.length; i ++){
                headText[i].style.fontSize = assets()[storageToken].headText;
            }
        };
        if(titleText.length > 0){
            let i;
            for(i = 0; i < titleText.length; i ++){
                titleText[i].style.fontSize = assets()[storageToken].titleText;
            }
        };
        if(baseText.length > 0){
            let i;
            for(i = 0; i < baseText.length; i ++){
                baseText[i].style.fontSize = assets()[storageToken].baseText;
                if(baseText[i].style.left){
                    const BaseLeftSize = Number(baseText[i].style.left.replace("px", "")) / assets()[typeState].tableCell;
                    const changeLeftSize = BaseLeftSize * assets()[storageToken].tableCell;
                    baseText[i].style.left = `${changeLeftSize}px`;
                }
            }
        };
        if(inputText.length > 0){
            let i;
            for(i = 0; i < inputText.length; i ++){
                inputText[i].style.fontSize = assets()[storageToken].baseText;
                inputText[i].style.height = assets()[storageToken].inputHeight;
            }
        };
        if(inputlabelText.length > 0){
            let i;
            for(i = 0; i < inputlabelText.length; i ++){
                inputlabelText[i].style.fontSize = assets()[storageToken].inputlabelText;
                inputlabelText[i].style.top = assets()[storageToken].inputlabelTop;
            }
        };
        if(buttonStyle.length > 0){
            let i;
            for(i = 0; i < buttonStyle.length; i ++){
                buttonStyle[i].style.height = assets()[storageToken].buttonHeight;
                buttonStyle[i].style.width = assets()[storageToken].buttonWidth;
                buttonStyle[i].style.fontSize = assets()[storageToken].baseText;
            }
        };
        if(iconButtonStyle.length > 0){
            let i;
            for(i = 0; i < iconButtonStyle.length; i ++){
                iconButtonStyle[i].style.height = assets()[storageToken].iconButtonHeight;
                iconButtonStyle[i].style.width = assets()[storageToken].iconButtonWidth;
                iconButtonStyle[i].style.fontSize = assets()[storageToken].baseText;
            }
        };
        if(svgStyle.length > 0){
            let i;
            for(i = 0; i < svgStyle.length; i ++){
                svgStyle[i].style.height = assets()[storageToken].svgHeight;
                svgStyle[i].style.width = assets()[storageToken].svgWidth;
            }
        };

        if(tableSvgStyle.length > 0){
            let i;
            for(i = 0; i < tableSvgStyle.length; i ++){
                tableSvgStyle[i].style.height = assets()[storageToken].tableSvgHeight;
                tableSvgStyle[i].style.width = assets()[storageToken].tableSvgWidth;
            }
        };
        if(categoryStyle.length > 0){
            let i;
            for(i = 0; i < categoryStyle.length; i ++){
                categoryStyle[i].style.height = assets()[storageToken].categoryHeight;
                categoryStyle[i].style.width = assets()[storageToken].categoryWidth;
            }
        };
        if(fontsizeButtonTooltipText.length > 0){
            let i;
            for(i = 0; i < fontsizeButtonTooltipText.length; i ++){
                fontsizeButtonTooltipText[i].style.fontSize = assets()[storageToken].fontsizeButtonTooltipText;
            }
        };
        if(anchorStyle.length > 0){
            let i;
            for(i = 0; i < anchorStyle.length; i ++){
                anchorStyle[i].style.height = assets()[storageToken].anchorHeight;
                anchorStyle[i].style.width = assets()[storageToken].anchorWidth;
                anchorStyle[i].style.fontSize = assets()[storageToken].baseText;
            }
        };
        if(tableCellStyle.length > 0){
            let i;
            for(i = 0; i < tableCellStyle.length; i ++){
                const BaseSize = Number(tableCellStyle[i].style.width.replace("px", "")) / assets()[typeState].tableCell;
                const changeSize = BaseSize * assets()[storageToken].tableCell;
                tableCellStyle[i].style.width = `${changeSize}px`;
                if(tableCellStyle[i].style.left){
                    const BaseLeftSize = Number(tableCellStyle[i].style.left.replace("px", "")) / assets()[typeState].tableCell;
                    const changeLeftSize = BaseLeftSize * assets()[storageToken].tableCell;
                    tableCellStyle[i].style.left = `${changeLeftSize}px`;
                }
            }
        };
        if(tableStyle.length > 0){
            let i;
            for(i = 0; i < tableStyle.length; i ++){
                const baseSize = Number(tableStyle[i].style.width.replace("px", ""))  / assets()[typeState].tableCell;
                const changeSize = baseSize * assets()[event.target.value].tableCell;
                if(changeSize !== 0)
                    tableStyle[i].style.width = `${changeSize}px`;
            }
        };
        if(tableSmallLabel.length > 0){
            let i;
            for(i = 0; i < tableSmallLabel.length; i ++){
            tableSmallLabel[i].style.fontSize = assets()[storageToken].tableSmallLabel;
            }
        };
        if(tableHeightsize.length > 0){
            let i;
            for(i = 0; i < tableHeightsize.length; i ++){
                tableHeightsize[i].style.maxHeight = assets()[storageToken].tableHeightsize;
            }
        };
        if(tableSmallHeightsize.length > 0){
            let i;
            for(i = 0; i < tableSmallHeightsize.length; i ++){
                tableSmallHeightsize[i].style.maxHeight = assets()[storageToken].tableSmallHeightsize;
            }
        };
        if(leftTableCellL.length > 0){
            let i;
            for(i = 0; i < leftTableCellL.length; i ++){
                leftTableCellL[i].style.width = assets()[storageToken].leftTableCellL;
                leftTableCellL[i].style.minWidth = assets()[storageToken].leftTableCellL;
                leftTableCellL[i].style.fontSize = assets()[storageToken].baseText;
            }
        };
        if(leftTableCellR.length > 0){
            let i;
            for(i = 0; i < leftTableCellR.length; i ++){
                leftTableCellR[i].style.width = assets()[storageToken].leftTableCellR;
                leftTableCellL[i].style.fontSize = assets()[storageToken].baseText;
            }
        };
        if(commentInputHeight.length > 0){
            let i;
            for(i = 0; i < commentInputHeight.length; i ++){
                commentInputHeight[i].style.height = assets()[storageToken].commentInputHeight;
            }
        };
        if(dialogButtonStyle.length > 0){
            let i;
            for(i = 0; i < dialogButtonStyle.length; i ++){
                dialogButtonStyle[i].style.fontSize = assets()[storageToken].baseText;
                dialogButtonStyle[i].style.height = assets()[storageToken].dialogButtonHeight;
                dialogButtonStyle[i].style.width = assets()[storageToken].dialogButtonWidth;
            }
        };
        if(priorityTagStyle.length > 0){
            let i;
            for(i = 0; i < priorityTagStyle.length; i ++){
                priorityTagStyle[i].style.fontSize = assets()[storageToken].baseText;
                priorityTagStyle[i].style.height = assets()[storageToken].tagHeight;
                priorityTagStyle[i].style.width = assets()[storageToken].priorityTagWidth;
            }
        }
        if(statusTagStyle.length > 0){
            let i;
            for(i = 0; i < statusTagStyle.length; i ++){
                statusTagStyle[i].style.fontSize = assets()[storageToken].baseText;
                statusTagStyle[i].style.height = assets()[storageToken].tagHeight;
                statusTagStyle[i].style.width = assets()[storageToken].statusTagWidth;
            }
        }
        if(newTagStyle.length > 0){
            let i;
            for(i = 0; i < newTagStyle.length; i ++){
                newTagStyle[i].style.fontSize = assets()[storageToken].baseText;
                newTagStyle[i].style.height = assets()[storageToken].tagHeight;
            }
        }
        if(tableSmalSVG.length > 0){
            let i;
            for(i = 0; i < tableSmalSVG.length; i ++){
                tableSmalSVG[i].style.width = assets()[storageToken].tableSmalSVG;
                tableSmalSVG[i].style.height = assets()[storageToken].tableSmalSVG;
            }
        }
        if(FormatButtonStyle.length > 0){
            let i;
            for(i = 0; i < FormatButtonStyle.length; i ++){
                FormatButtonStyle[i].style.fontSize = assets()[storageToken].baseText;
                FormatButtonStyle[i].style.height = assets()[storageToken].formatButtonHeight;
                FormatButtonStyle[i].style.width = assets()[storageToken].formatButtonWidth;
            }
        }

    };


    return (
        <>
            <SdivWrapper>
                <SdivButton onChange={(event)=>onClickFontSize(event)}>
                    <SspanTooltip className='fontsizeButtonTooltipText'style={{fontSize:assets().size.fontsizeButtonTooltipText}} visible={visible}>フォントサイズ</SspanTooltip>
                    <SinputRadio id='radio1' name='name'type='radio' value='large'/>
                    <SlabelFonsSize id='first' htmlFor='radio1' state={typeState} type={'large'} onMouseOver={() => setVisible(true)}  onMouseLeave={() => setVisible(false)}>大</SlabelFonsSize>
                    <SinputRadio id='radio2' name='name'type='radio' value='medium'/>
                    <SlabelFonsSize id='second' htmlFor='radio2'state={typeState} type={'medium'} onMouseOver={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>中</SlabelFonsSize>
                    <SinputRadio id='radio3' name='name'type='radio' value='small'/>
                    <SlabelFonsSize id='third' htmlFor='radio3' state={typeState} type={'small'}onMouseOver={() => setVisible(true)} onMouseLeave={() => setVisible(false)}> 小</SlabelFonsSize>
                </SdivButton>
            </SdivWrapper>
        </>
    )
}